import { Component, Input } from '@angular/core';
import { CheckoutStep } from '../../models';

@Component({
  selector: 'payment-title',
  templateUrl: './payment-title.component.html',
  styleUrls: ['./payment-title.component.scss'],
})
export class PaymentTitleComponent {
  @Input() accountNumbers: string[];
  @Input() currentStep: CheckoutStep;

  readonly maxAccountsToList = 3;
  readonly checkoutStepEnum = CheckoutStep;
  isAccountsDialogVisible = false;

  formatAccountNumbers(): string {
    return this.accountNumbers?.length > this.maxAccountsToList
      ? `${this.accountNumbers.slice(0, this.maxAccountsToList).join(', ')}...`
      : this.accountNumbers?.join(', ');
  }
}
